const state = {

}

const actions =  {
  getAllBeneficiaries: async ({}, plans) => {
     return plans.reduce((listBeneficiaries, p) => listBeneficiaries.concat(p.beneficiarios), [])
        .reduce((newList, e) => (newList.findIndex(item => item.cpf == e.cpf) == -1)? newList.concat(e) : newList, [])
    },
  async sendMail({commit}, opts){
      let _this = this
      let obj = {
        url: 'new-card',
        query: opts,
        method: 'post',
        api: 'criare'
      }
      await _this.dispatch('request/doRequest', obj).then(resp => {
        let paramModal = {}
        paramModal.message = resp.data.message
        paramModal.title = 'Sucesso'
        paramModal.type = 'success'
        paramModal.btConfirm = {
          name: 'Ok',
          show: true
        }
        paramModal.btCancel = {
          show: false
        }
        _this.commit('confirmMessage/showConfirmMessage', paramModal)
      })
      return true
    },
}

export default {
  namespaced: true,
  root: true,
  state,
  actions
}
